import { type ErrorComponentProps, useNavigate } from '@tanstack/react-router'

import Button from '@ingka/button'
import Image from '@ingka/image'
import Text from '@ingka/text'

import { useKiosk } from '@/hooks/use-kiosk'
import { useTranslate } from '@/hooks/use-translate'
import { getCountryFromPath, getLanguageFromPath } from '@/utils/base-path-params'

import { errorWrapper, prompt, promptWrapper } from './error-component.module.css'

export function ErrorComponent({ error }: ErrorComponentProps) {
  const navigate = useNavigate()
  const { kioskIntegration, platform } = useKiosk()
  const { translateString } = useTranslate()

  if (platform !== 'web') {
    kioskIntegration.error(error.message)
  }

  return (
    <div className={errorWrapper}>
      <div className={promptWrapper}>
        <Image src={`${import.meta.env.BASE_URL}images/broken-table.avif`} width={400} />
        <Text tagName="strong" textStyle="Heading.L">
          {translateString('error.something_went_wrong')}
        </Text>
        <div className={prompt}>
          <Button
            onClick={() => {
              void navigate({
                params: {
                  country: getCountryFromPath().toLowerCase(),
                  language: getLanguageFromPath(),
                },
                to: '/$country/$language',
              })
            }}
            text={translateString('common.go_back')}
            type="primary"
          />
          <details>
            <summary>{translateString('error.view_error_details')}</summary>
            <div>{error.message ? <code>{error.message}</code> : null}</div>
          </details>
        </div>
      </div>
    </div>
  )
}
